 
export const SHOW_DETAIL = 'SHOW_DETAIL'
export const UPDATE_DETAIL_DAY = 'UPDATE_DETAIL_DAY'
export const GRAPH_INIT = 'GRAPH_INIT'
export const STATIONS_INIT = 'STATIONS_INIT'
export const SELECT_STATIONS = 'SELECT_STATIONS'
export const GET_DATA = 'GET_DATA'
export const SELECT_GASES = 'SELECT_GASES'
export const SELECT_GLOBAL_DAY = 'SELECT_GLOBAL_DAY'